import { NavItem } from '@billy/design-system'
import { TFunction } from 'i18next'

import { InvoicePaymentTermValue } from '../types/invoicePaymentTermValue'
import { getDaysRemainingToEndOfMonth } from './getDaysRemainingToEndOfMonth'

export const getItems = (
  invoicePaymentTerms: InvoicePaymentTermValue[],
  t: TFunction,
  issueDate: Date,
): NavItem<InvoicePaymentTermValue>[] => {
  const items = invoicePaymentTerms.map((paymentTerm) => ({
    id: String(paymentTerm),
    children: t('days_count', { count: paymentTerm }),
    value: paymentTerm,
  }))

  const endOfMonthTerm = getDaysRemainingToEndOfMonth(issueDate)

  return [
    ...items,
    {
      id: String(endOfMonthTerm),
      children: t('external_invoices.editor.form.field.due_date_and_payment_term.select_term.end_of_month.label'),
      value: endOfMonthTerm,
    },
  ]
}
